module.exports = __webpack_public_path__ + "static/media/CC20-AP160-12-FAICO.b69394d4.pdf";